export enum StatsApiManualFormMode {
  StatsAPI = 'Stats API',
  Manual = 'Manual',
}
